module.exports = __webpack_public_path__ + "static/media/480.cc8426a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-natural-food/light/480.png
// module id = 2266
// module chunks = 2